export enum TimingOptions {
  During = 'during',
  Before = 'before',
  After = 'after',
}
